// v14m.1 — Inklapbare instellingensectie met chevron.
// Persistente open/dicht-state per sectie in sessionStorage.
// Meerdere secties tegelijk open is toegestaan.
import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Props:
 *  id      — sessionStorage-sleutel, uniek per sectie.
 *  title   — h2-tekst.
 *  icon    — optioneel React-node vóór titel.
 *  defaultOpen — bij ontbreken van state in sessionStorage.
 *  testid  — data-testid prefix.
 *  children — inhoud onder de titel.
 */
export default function CollapsibleSettingsCard({
  id,
  title,
  icon = null,
  defaultOpen = false,
  testid = "",
  children,
}) {
  const storageKey = `emma.settings.section.${id}`;
  const [open, setOpen] = useState(() => {
    try {
      const v = sessionStorage.getItem(storageKey);
      if (v === "1") return true;
      if (v === "0") return false;
    } catch (_) { /* sessionStorage kan geblokkeerd zijn */ }
    return !!defaultOpen;
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(storageKey, open ? "1" : "0");
    } catch (_) { /* ignore */ }
  }, [open, storageKey]);

  return (
    <div className="emma-card p-0 overflow-hidden" data-testid={testid || `section-${id}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 py-4 sm:px-5 sm:py-4 text-left hover:bg-[#FAF9F6] transition-colors"
        data-testid={`${testid || `section-${id}`}-toggle`}
        aria-expanded={open}
      >
        <ChevronDown
          className={`w-4 h-4 text-[#B07A4F] transition-transform flex-shrink-0 ${open ? "" : "-rotate-90"}`}
        />
        {icon}
        <h2 className="font-heading text-lg font-bold text-[#2C2C2A] flex-1 truncate">{title}</h2>
      </button>
      {open && (
        <div className="px-4 pb-5 sm:px-5 sm:pb-5 pt-0 space-y-4" data-testid={`${testid || `section-${id}`}-body`}>
          {children}
        </div>
      )}
    </div>
  );
}
